const calcSecFromDate = (date: number, offset = 0): number =>
  Math.max((date - Date.now() + offset) / 1000, 0);

const parseDateToISO = (date: string): number => {
  const parsedDate = Date.parse(date);
  return Number.isNaN(parsedDate) ? 0 : parsedDate;
};

export { calcSecFromDate, parseDateToISO };
